export const parseCommaSeparatedValues = (values: string) => {
  if (!values) {
    return []
  }

  return values.split(',')
}
